import {Component, OnDestroy, OnInit} from '@angular/core';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ResourcesHubService} from "../../core/resources-hub.service";
import {ChangeEvent} from "@ckeditor/ckeditor5-angular";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {addResources} from "../../../../shared/constants/validation.constants";
import {CommonService} from "../../../../shared/services/common.service";

@Component({
  selector: 'app-add-text',
  templateUrl: './add-text.component.html',
  styleUrls: ['./add-text.component.css']
})
export class AddTextComponent implements OnInit, OnDestroy {
  editorForm: FormGroup = new FormGroup<any>({
    content: new FormControl('', [
      Validators.required, Validators.minLength(addResources.text.length.min)
    ])
  })
  public Editor = ClassicEditor;
  data: any;
  editorTextChangeEmitter: Subject<any> = new Subject();
  errorMessages: any = {};
  errorMessageMap = {
    title: {
      content: 'This field is required',
      minlength: `Minimum ${addResources.text.length.min} characters required`,
    },
  };
  uuid:any;
  config:any
  private readonly onDestroy: Subject<any> = new Subject<any>();


  constructor(private resourceHubService: ResourcesHubService, private commonService: CommonService) {
    this.config = {
      toolbar: [
        'undo', 'redo',
        '|', 'heading',
        '|', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
        '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript',
        'code',
        '|', 'link', 'insertTable', 'blockQuote', 'codeBlock',
        '|', 'alignment',
        '|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
      ],
      link : {
        addTargetToExternalLinks: true
      },
      image: null,
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      language: 'en',
    }
  }


  ngOnInit(): void {
    this.uuid = this.data.layoutData.uuid

    this.editorForm.patchValue({
      content: this.data.layoutData.content
    })

    this.editorTextChangeEmitter.pipe(takeUntil(this.onDestroy), debounceTime(3000))
      .subscribe(data => {
        this.resourceHubService.setLastUpdatedId(null)
        this.resourceHubService.sendDataToParent(data)
      })
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.editorForm, this.errorMessageMap, currentField))
    };
  }

  onChange({editor}: ChangeEvent) {
    const data = editor.data.get();
    let updatedData: any = JSON.parse(JSON.stringify(this.data));
    updatedData.layoutData.content = data;
    this.editorTextChangeEmitter.next(updatedData)
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
